import { vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-sm-12" }
const _hoisted_3 = { class: "form-check small mb-0" }
const _hoisted_4 = {
  class: "form-check-label",
  for: "isAgreeBlacklistPaymentMethod"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormInputWrapper = _resolveComponent("FormInputWrapper")!
  const _component_LoaderWrapper = _resolveComponent("LoaderWrapper")!
  const _component_b_modal = _resolveComponent("b-modal")!

  return (_openBlock(), _createBlock(_component_b_modal, {
    title: "",
    modelValue: _ctx.item !== null,
    "footer-class": "border-top-0 d-flex justify-content-between",
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ($event === false && (_ctx.item = null)))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_FormInputWrapper, {
            field: "isAgreeBlacklistPaymentMethod",
            form: "requisitesForm"
          }, {
            default: _withCtx((parentProps) => [
              _createElementVNode("div", {
                class: _normalizeClass(["alert alert-danger mb-0", parentProps.class]),
                role: "alert"
              }, [
                _createElementVNode("div", _hoisted_3, [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.isAgreeBlacklistPaymentMethod) = $event)),
                    type: "checkbox",
                    value: "",
                    id: "isAgreeBlacklistPaymentMethod"
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.form.isAgreeBlacklistPaymentMethod]
                  ]),
                  _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.helper.trans('labels.agree_with_risk')), 1)
                ])
              ], 2)
            ]),
            _: 1
          })
        ])
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.item = null)),
        class: "btn btn-outline-dark btn-sm text-capitalize-first"
      }, _toDisplayString(_ctx.helper.trans('button.cancel')), 1),
      _createVNode(_component_LoaderWrapper, {
        ref: "loader",
        zoom: 0.5
      }, {
        default: _withCtx(() => [
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onOkClick())),
            class: "btn btn-outline-danger btn-sm text-capitalize-first"
          }, _toDisplayString(_ctx.helper.trans('button.ok')), 1)
        ]),
        _: 1
      }, 512)
    ]),
    _: 1
  }, 8, ["modelValue"]))
}